module.exports = {"jobs":{"env":{"dev":"http://localhost:3000/api/v1/cms","production":"https://139-144-186-224.ip.linodeusercontent.com/api/v1/cms"}},"imageHandler":"https://static.gold360.com.br"}


//////////////////
// WEBPACK FOOTER
// ./src/env-config.json
// module id = TwO6
// module chunks = 21